import { Button } from "../../../components/Button/Button.tsx";
import {
  type IntercomArticle,
  openIntercomArticleInMessenger,
} from "../../../utils/intercom.ts";

export const LearnMoreLink = ({
  className,
  intercomArticle,
}: {
  className?: string;
  intercomArticle: IntercomArticle;
}) => (
  <Button
    className={className}
    variant="tertiary"
    onClick={() => openIntercomArticleInMessenger(intercomArticle)}
    iconName="ArrowUpRight"
    iconPosition="right"
  >
    <span className="underline">Learn More</span>
  </Button>
);
